import { render, staticRenderFns } from "./preview-recipients.vue?vue&type=template&id=610a88ab&scoped=true&"
import script from "./preview-recipients.vue?vue&type=script&lang=js&"
export * from "./preview-recipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610a88ab",
  null
  
)

export default component.exports